// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    List,
    Text,
    Translate,
} from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { useMemo } from 'react';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    storages: IComputeResourceRecoveryReadinessStatusResponse['destination_compute_resources'][number]['compatibility_details']['incompatible_storages'];
}

export default function StorageTypesConflictDialog({
    isOpen,
    onClose,
    storages,
}: IProps) {

    const columns = useMemo(() => [
        {
            key: 'type',
            title: <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.dialogs.storageTypes.table.type'} />,
        },
        {
            key: 'tier',
            title: <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.dialogs.storageTypes.table.tier'} />,
        },
    ], []);

    return (
        <Dialog
            isOpen={isOpen}
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.storageTypes" />}
            size={'sm'}
            closeHandler={onClose}
        >
            <Text component={'p'}>
                <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.dialogs.storageTypes.caption'} />
            </Text>

            <List
                columns={columns}
                data={storages}
                rowKey={(row) => `${row.type}-${row.tier ?? '-'}`}
            />
        </Dialog>
    );
}